// @ts-nocheck
import 'antd/dist/antd.css';
import React, { useState, useEffect, useMemo } from 'react';
import AntForm, { configure } from './ant-form';
import { Button, Dropdown, Menu, Card } from 'antd';
import useAntForm from './hooks/useAntForm';
import moment from 'moment';

configure({
  actionsWrapperProps: {
    className: 'actions',
  },
});

const ObjectInspector = ({ object }) => {
  return (
    <div
      style={{
        padding: 15,
        margin: '15px 0',
        border: '1px solid #efefef',
        borderRadius: 4,
      }}
    >
      {Object.keys(object).map((key) => (
        <div key={key}>
          {key}:&nbsp; {object[key]}
        </div>
      ))}
    </div>
  );
};

export const Basic = () => (
  <AntForm
    object={{ date: '2022-01-01' }}
    errors={{ firstname: ['is required'] }}
    onSubmit={(values) => console.log(values)}
    schema={[
      <h2 key="paragraph">Basic AntForm</h2>,
      [
        {
          name: 'firstname',
          label: 'Firstname',
          input: {
            type: 'string',
          },
          colProps: {
            xs: 24,
            md: 12,
            lg: 12,
          },
        },
        {
          name: 'lastname',
          label: 'Lastname',
          input: {
            type: 'string',
          },
          colProps: {
            xs: 24,
            md: 12,
            lg: 12,
          },
        },
      ],
      [
        {
          name: 'select',
          label: 'Select',
          input: {
            type: 'select',
            options: [
              {
                label: 'Option 1',
                value: 'one',
              },
              {
                label: 'Option 2',
                value: 'two',
              },
              {
                label: 'Option 3',
                value: 'three',
              },
            ],
          },
          colProps: {
            xs: 24,
            md: 12,
          },
        },
        {
          name: 'disabledselect',
          label: 'Disabled Select',
          input: {
            type: 'select',
            options: [
              {
                label: 'Option 1',
                value: 'one',
              },
            ],
            inputProps: {
              disabled: true,
            },
          },
          colProps: {
            xs: 24,
            md: 12,
          },
        },
      ],
      {
        name: 'checkbox',
        input: {
          type: 'checkbox',
          text: 'Checkbox',
        },
      },
      {
        name: 'switch',
        label: 'Switch',
        input: {
          type: 'switch',
        },
      },
      [
        {
          name: 'date',
          label: 'Datepicker',
          input: {
            type: 'date',
            inputProps: {
              format: 'L',
            },
          },
          colProps: {
            xs: 12,
          },
        },
        {
          name: 'rate',
          label: 'Rate',
          input: {
            type: 'rate',
            inputProps: {
              allowHalf: true,
              allowClear: true,
              count: 6,
            },
          },
          colProps: {
            xs: 12,
          },
        },
      ],
      {
        name: 'textarea',
        label: 'Textarea',
        input: {
          type: 'text',
        },
      },
      [
        {
          name: 'slider',
          label: 'Slider',
          input: {
            type: 'slider',
            inputProps: {
              defaultValue: 30,
            },
          },
          colProps: {
            xs: 24,
            md: 12,
          },
        },
        {
          name: 'rangeslider',
          label: 'Range Slider',
          input: {
            type: 'slider',
            inputProps: {
              range: true,
              defaultValue: [20, 50],
            },
          },
          colProps: {
            xs: 24,
            md: 12,
          },
        },
      ],
      {
        name: 'password',
        label: 'password',
        input: {
          type: 'password',
        },
      },
      {
        name: 'logo',
        input: {
          type: 'upload',
          inputProps: {
            addComponent: <Button type="primary">Choisir un fichier</Button>,
          },
        },
      },
    ]}
  />
);

export const AdvancedUploader = () => (
  <Card>
    <AntForm
      object={{}}
      errors={{ firstname: ['is required'] }}
      onSubmit={(values) => console.log(values)}
      schema={[
        {
          name: 'logo',
          input: {
            type: 'upload',
            inputProps: {
              listType: 'picture-card',
              showUploadList: false,
              addComponent: (
                <img
                  src="https://via.placeholder.com/350x150"
                  alt="file"
                  style={{ width: '100%' }}
                />
              ),
            },
          },
        },
        {
          name: 'file',
          input: {
            type: 'upload',
            inputProps: {
              // @ts-ignore
              addComponent: (
                <Button className={`text-underline`}>
                  Sélectionner un fichier
                </Button>
              ),
            },
          },
        },
      ]}
    />
  </Card>
);

export const RadiosAndCheckboxes = () => {
  const checkboxesOptions = [
    {
      value: 'one',
      label: 'Option one',
    },
    {
      value: 'two',
      label: 'Option two',
    },
    {
      value: 'disabled',
      label: 'Option disabled',
      disabled: true,
    },
  ];
  return (
    <AntForm
      layout="vertical"
      onSubmit={() => undefined}
      rowProps={{
        gutter: 16,
      }}
      schema={[
        {
          name: 'checkbox',
          input: {
            type: 'checkbox',
            text: 'Checkbox',
          },
        },
        {
          name: 'checkboxes',
          label: 'Checkboxes',
          input: {
            type: 'checkboxes',
            options: checkboxesOptions,
          },
        },
        {
          name: 'radios',
          label: 'Radios',
          input: {
            type: 'radio',
            options: checkboxesOptions,
          },
        },
        {
          name: 'radios',
          label: 'Vertical Radios',
          input: {
            type: 'radio',
            options: checkboxesOptions,
            layout: 'vertical',
          },
        },
        {
          name: 'radiobuttons',
          label: 'Radio buttons',
          input: {
            type: 'radio',
            style: 'button',
            options: checkboxesOptions,
          },
        },
      ]}
    />
  );
};

const placeholder =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac arcu in augue hendrerit laoreet. Sed sodales nisl a nisl tempor laoreet. Aliquam metus lacus, ornare nec accumsan vitae, iaculis vel enim. Fusce eu blandit ligula. Vivamus a mi dolor. Fusce gravida commodo mi, ut hendrerit augue ultrices nec. Sed sagittis nisi lacus, a efficitur ex porttitor vitae. In vehicula hendrerit faucibus. Nunc aliquam rutrum odio sagittis porta. Morbi scelerisque orci sed placerat interdum. Nulla at massa venenatis sem semper aliquet nec nec quam. Maecenas congue cursus venenatis.';

export const Textarea = () => (
  <AntForm
    layout="vertical"
    object={{ autosized: placeholder, default: placeholder }}
    onSubmit={() => undefined}
    schema={[
      {
        name: 'default',
        label: 'Default',
        input: {
          type: 'text',
        },
      },
      {
        name: 'autosized',
        label: 'Autosize',
        input: {
          type: 'text',
          inputProps: {
            autoSize: true,
          },
        },
      },
    ]}
  />
);

export const WithErrors = () => {
  const [object, setObject] = useState({
    surname: null,
    firstname: 'Bruce',
    lastname: null,
  });
  return (
    <AntForm
      layout="vertical"
      object={object}
      onChange={(value, values) => setObject(values)}
      errors={{ lastname: ['lastname is required'] }}
      schema={[
        {
          name: 'firstname',
          label: 'Firstname',
          input: {
            type: 'string',
            required: true,
          },
        },
        {
          name: 'lastname',
          label: 'Lastname',
          required: true,
          input: {
            type: 'string',
            required: true,
          },
        },
        {
          name: 'surname',
          label: 'Surname',
          errorKey: 'lastname',
        },
        <ObjectInspector key="inspector" object={object} />,
      ]}
    />
  );
};

export const Layout = () => {
  const [object, setObject] = useState({ layout: 'vertical' });
  return (
    <AntForm
      onChange={(value, values) => setObject(values)}
      object={object}
      layout={object.layout}
      schema={[
        {
          name: 'layout',
          label: 'Layout',
          input: {
            type: 'radio',
            style: 'button',
            options: [
              {
                label: 'Vertical',
                value: 'vertical',
              },
              {
                label: 'Horizontal',
                value: 'horizontal',
              },
              {
                label: 'Inline',
                value: 'inline',
              },
            ],
          },
        },
        {
          name: 'firstname',
          label: 'Firstname',
          input: {
            type: 'string',
          },
        },
        {
          name: 'lastname',
          label: 'Lastname',
          input: {
            required: true,
            type: 'string',
          },
        },
      ]}
    />
  );
};

export const Internationalization = () => {
  const [locale, setLocale] = useState('en');

  const schema = useMemo(
    () => [
      {
        name: 'title',
        label: 'Titre traduit',
        input: {
          type: 'string',
          localize: true,
        },
      },
      {
        name: 'Commentaire',
        label: 'Texte traduit',
        input: {
          type: 'text',
          localize: true,
        },
      },
    ],
    [],
  );

  const object = { title: { fr: 'FR', en: 'EN' } };

  const onMenuChange = ({ key }) => setLocale(key);
  return (
    <div style={{ padding: 16 }}>
      <Dropdown
        trigger="hover"
        overlay={
          <Menu onClick={onMenuChange}>
            <Menu.Item key="fr">FR</Menu.Item>
            <Menu.Item key="en">EN</Menu.Item>
          </Menu>
        }
      >
        <a>
          Locale :&nbsp;
          {locale}
        </a>
      </Dropdown>
      <AntForm
        onSubmit={(values) => console.log(values)}
        object={object}
        locale={locale}
        schema={schema}
      />
    </div>
  );
};

export const Responsive = () => (
  <AntForm
    object={{}}
    schema={[
      [
        <p key="paragraph">
          Responsive options are provided in colProps property of each field
        </p>,
        {
          name: 'firstname',
          label: 'Firstname',
          input: {
            type: 'string',
          },
          colProps: {
            xs: 24,
            md: 12,
            lg: 12,
          },
        },
        {
          name: 'lastname',
          label: 'Lastname',
          input: {
            type: 'string',
          },
          colProps: {
            xs: 24,
            md: 12,
            lg: 12,
          },
        },
      ],
      [
        {
          name: 'offset',
          label: 'Offset',
          input: {
            type: 'string',
          },
          colProps: {
            md: { span: 6, offset: 6 },
          },
        },
      ],
    ]}
  />
);

export const ExtraActions = () => {
  const [object, setObject] = useState({ lastname: 'Wayne' });
  return (
    <>
      <AntForm
        object={object}
        onChange={(value, values) => setObject(values)}
        onSubmit={() => undefined}
        extraActions={[<Button type="default">Cancel</Button>]}
        actionsWrapperProps={{
          className: 'actions-wrapper',
          style: {
            backgroundColor: '#EFEFEF',
          },
        }}
        schema={[
          {
            name: 'lastname',
            label: 'lastname',
            type: {
              type: 'string',
            },
          },
        ]}
      />
      <ObjectInspector key="inspector" object={object} />
    </>
  );
};

export const Readonly = () => {
  const [object, setObject] = useState({ lastname: 'Wayne' });
  return (
    <>
      <AntForm
        object={object}
        readOnly
        onChange={(value, values) => setObject(values)}
        onSubmit={() => undefined}
        schema={[
          {
            name: 'lastname',
            label: 'lastname',
            type: {
              type: 'string',
            },
          },
        ]}
      />
      <ObjectInspector key="inspector" object={object} />
    </>
  );
};

export const Size = () => {
  const [object, setObject] = useState({
    size: 'default',
    time: moment().format(),
  });
  return (
    <AntForm
      object={object}
      layout="vertical"
      colon={false}
      size={object.size}
      onChange={(value, values) => setObject(values)}
      onSubmit={() => console.log(object)}
      schema={[
        {
          name: 'size',
          label: 'Size',
          input: {
            type: 'radio',
            options: [
              {
                value: 'small',
                label: 'Small',
              },
              {
                value: 'default',
                label: 'Default',
              },
              {
                value: 'large',
                label: 'Large',
              },
            ],
          },
        },
        [
          {
            name: 'firstname',
            label: 'Firstname',
            input: {
              type: 'string',
            },
            colProps: {
              xs: 24,
              md: 12,
              lg: 12,
            },
          },
          {
            name: 'lastname',
            label: 'Lastname',
            input: {
              type: 'string',
            },
            colProps: {
              xs: 24,
              md: 12,
              lg: 12,
            },
          },
        ],
        {
          name: 'switch',
          label: 'Switch',
          input: {
            type: 'switch',
          },
        },
        [
          {
            name: 'date',
            label: 'Datepicker',
            input: {
              type: 'date',
              inputProps: {
                format: 'L',
              },
            },
            colProps: {
              xs: 12,
            },
          },
          {
            name: 'time',
            label: 'Time',
            input: {
              type: 'time',
            },
            colProps: {
              xs: 12,
            },
          },
          {
            name: 'rate',
            label: 'Rate',
            input: {
              type: 'rate',
              inputProps: {
                allowHalf: true,
                allowClear: true,
                count: 6,
              },
            },
            colProps: {
              xs: 12,
            },
          },
        ],
        {
          name: 'textarea',
          label: 'Textarea',
          input: {
            type: 'text',
          },
        },
      ]}
    />
  );
};

export const ProxyField = () => {
  const [object, setObject] = useState({ lastname: null, surname: null });
  return (
    <AntForm
      object={object}
      onChange={(value, values) => setObject(values)}
      schema={[
        <p key="paragraph">
          Proxy allow to automatically assign value into an another properties.
          <br />
          If the value returned by your component is an object, a path can be
          configured for assign a property of this object to a property of the
          form object
        </p>,
        {
          name: 'lastname',
          label: 'lastname',
          proxy: {
            name: 'surname',
          },
          type: {
            type: 'string',
          },
        },
        <ObjectInspector key="inspector" object={object} />,
      ]}
    />
  );
};

export const antFormHook = () => {
  const { object, dirty, onReset, onChange, set } = useAntForm({
    lastname: 'Wayne',
  });

  useEffect(() => {
    set({ lastname: 'Wayne 2' });
  }, []);

  return (
    <AntForm
      object={object}
      onChange={onChange}
      onSubmit={() => console.log(object)}
      extraActions={[
        <Button type="default" onClick={onReset}>
          Reset
        </Button>,
      ]}
      schema={[
        <div>{dirty && <span>Dirty !!!</span>}</div>,
        {
          name: 'lastname',
          label: 'lastname',
          type: {
            type: 'string',
          },
        },
        <ObjectInspector key="inspector" object={object || {}} />,
      ]}
    />
  );
};

const SampleComposition = () => {
  const [object, setObject] = useState();
  return (
    <AntForm
      object={object}
      onChange={(value, values) => setObject(values)}
      schema={[
        {
          name: 'lastname',
          label: 'lastname',
          type: {
            type: 'string',
          },
        },
        <ObjectInspector key="inspector" object={object} />,
      ]}
    />
  );
};
